import { hideFrameStyles } from 'wrapper/lib/frames/utils/frameDisplayStyles'
import { PROMPT_TAG, APP_ERROR_TAG } from 'common/tags'
import { unlockPage } from './toggleBodyScroll'

const HideIFrame = (tag) => {
    const unlockTags = [PROMPT_TAG, APP_ERROR_TAG]
    const isUnlockTag = unlockTags.includes(tag)
    const element = document.getElementById(tag)

    if (element) {
        Object.assign(element.style, hideFrameStyles)
        element.removeAttribute('visible')
    }

    if (isUnlockTag) {
        unlockPage()
    }
}

export default HideIFrame
